import {
  PaymentproviderType,
  PaymentproviderTypeAmazon,
  PaymentproviderTypePaypal,
  PaymentproviderTypePaypalApplePay,
  PaymentproviderTypePaypalGooglePay,
  PaymentproviderTypeSixpayment,
  PaymentproviderTypeUeberweisung,
} from './paymentprovider-type.model';

export const paymentproviderTypes: PaymentproviderType[] = [
  { id: PaymentproviderTypePaypal, name: 'Paypal', img: 'paypal.png', imgheight: 70 },
  { id: PaymentproviderTypeUeberweisung, name: 'Überweisung', img: 'ueberweisung.png', imgheight: 40 },
  { id: '3', name: 'Sofortüberweisung', img: 'klarna.png', imgheight: 70 },
  { id: PaymentproviderTypeAmazon, name: 'Amazon Pay', img: 'amazonpay.png', imgheight: 30 },
  { id: PaymentproviderTypeSixpayment, name: 'Sixpayment', img: 'sixpayment.png', imgheight: 87 },
  { id: '10', name: 'Paypal', img: 'paypalv2.png', imgheight: 30 },
  { id: '11', name: 'Giropay', img: 'giropayoverpaypalv2.png', imgheight: 70 },
  { id: '12', name: 'Sofortüberweisung', img: 'sofortueberweisungoverpaypalv2.png', imgheight: 80 },
  { id: '13', name: 'Kreditkarte', img: 'kreditkarteoverpaypalv2.png', imgheight: 70 },
  { id: PaymentproviderTypePaypalApplePay, name: 'Apple Pay', img: 'applepay.svg', imgheight: 70 },
  { id: PaymentproviderTypePaypalGooglePay, name: 'Google Pay', img: 'googlepay.png', imgheight: 70 },
  { id: '20', name: 'Sofortüberweisung', img: 'sofortueberweisungoverpayonelink.png', imgheight: 80 },
  { id: '21', name: 'Giropay', img: 'giropayoverpayonlelink.png', imgheight: 70 },
  { id: '22', name: 'Kreditkarte', img: 'kreditkarteoverpayonelink.png', imgheight: 70 },
];
